/**
 * Sales channels decide where a product may be sold. Client-safe module shared
 * by admin, storefront and the pack engine.
 *
 * Every existing product defaults to `individual`, which is what the storefront
 * catalog has always shown — adding a channel is purely additive.
 */
export const SALES_CHANNELS = [
  { id: "individual", label: "Individual", description: "Sold on its own in the storefront catalog." },
  { id: "discovery", label: "Discovery Pack", description: "Selectable inside Discovery packs." },
  { id: "retail", label: "Retail Pack", description: "Selectable inside retail packs." },
  { id: "corporate", label: "Corporate Pack", description: "Selectable inside corporate packs." },
  { id: "wholesale", label: "Wholesale Pack", description: "Selectable inside wholesale packs." },
  { id: "gift", label: "Gift Pack", description: "Selectable inside gift packs." },
  { id: "festival", label: "Festival Pack", description: "Selectable inside festival packs." },
] as const;

export type SalesChannelId = (typeof SALES_CHANNELS)[number]["id"];

export const DEFAULT_SALES_CHANNEL: SalesChannelId = "individual";

/** Normalises a stored value, always guaranteeing at least the default channel. */
export function normalizeSalesChannels(value: unknown): string[] {
  const list = Array.isArray(value) ? value.filter((v): v is string => typeof v === "string" && v.length > 0) : [];
  const unique = Array.from(new Set(list));
  return unique.length > 0 ? unique : [DEFAULT_SALES_CHANNEL];
}

export function salesChannelLabel(id: string): string {
  return SALES_CHANNELS.find((c) => c.id === id)?.label ?? id;
}